import React, { useState } from "react";
import { Bell, BellRing, BellOff } from "lucide-react";
import { toast } from "sonner";

export const NotifyButton = ({ request }) => {
  const [perm, setPerm] = useState(typeof Notification !== "undefined" ? Notification.permission : "unsupported");
  const Icon = perm === "granted" ? BellRing : perm === "denied" ? BellOff : Bell;
  const label = perm === "granted" ? "Alerts on" : perm === "denied" ? "Alerts blocked" : perm === "unsupported" ? "Alerts unsupported" : "Enable alerts";

  const onClick = async () => {
    const p = await request();
    setPerm(p);
    if (p === "granted") toast.success("Browser alerts enabled");
    else if (p === "denied") toast.error("Alerts blocked — allow notifications in browser settings");
  };

  return (
    <button
      onClick={onClick}
      disabled={perm === "granted" || perm === "unsupported"}
      data-testid="enable-notifications-btn"
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border text-xs font-bold transition-colors ${perm === "granted" ? "bg-emerald-500/10 border-emerald-500/30 text-emerald-300" : "bg-cyan-500/10 border-cyan-500/30 text-cyan-300 hover:bg-cyan-500/20"}`}
    >
      <Icon size={13} /> {label}
    </button>
  );
};
